import React from 'react'
import { Info } from 'lucide-react'
import './Header.css'

interface HeaderProps {
  onAboutClick: () => void
}

const Header: React.FC<HeaderProps> = ({ onAboutClick }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/favicon.svg" alt="JSONBox" className="logo-icon" />
          <div className="logo-text">
            <h1>JSONBox</h1>
          </div>
        </div>
        <div className="header-buttons">
          <button 
            onClick={onAboutClick}
            className="about-btn"
            title="About JSONBox"
          >
            <Info size={16} />
            About
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
